import Skeleton from 'react-loading-skeleton';
import {ProjectCard} from '../../../Components';
import './SmartProjectCard.css'

const SmartProjectCard = ({ loading, error, project }) => {
    if (loading  || error || !project) {
        return (
            <li className="project-skeleton-card">
                <Skeleton 
                    height={300} 
                    style={{ borderRadius: '0px', marginBottom: '15px' }} 
                    baseColor="var(--bg-footer)" 
                    highlightColor="var(--bg-body)" 
                />
                <Skeleton 
                    height={25} 
                    width="65%" 
                    style={{ borderRadius: '0px', marginBottom: '15px' }} 
                    baseColor="var(--bg-footer)" 
                    highlightColor="var(--bg-body)" 
                />
                <Skeleton 
                    height={20} 
                    width="75%" 
                    style={{ borderRadius: '0px' }} 
                    baseColor="var(--bg-footer)" 
                    highlightColor="var(--bg-body)" 
                />
            </li>
        );
    }

    return (
        <ProjectCard
            id={project.id}
            projectImg={project.projectImg}
            projectTitle={project.projectTitle}
            date={project.date}
            client={project.client}
        />
    );
};

export default SmartProjectCard;
